import { Link } from 'react-router-dom'

interface VendorCardProps {
  vendor: {
    id: string
    user_id?: string
    vendor_name: string
    vendor_description: string | null
    vendor_email: string | null
    vendor_phone: string | null
    vendor_logo_url: string | null
    vendor_type?: string
  }
}

export default function VendorCard({ vendor }: VendorCardProps) {
  // Determine the link based on vendor type
  const getVendorLink = () => {
    if (vendor.vendor_type === 'broadcaster') {
      return `/broadcasters/${vendor.user_id || vendor.id}`
    } else if (vendor.vendor_type === 'ad-creator') {
      return `/ad-creators/${vendor.user_id || vendor.id}`
    }
    return null
  }

  const link = getVendorLink()
  const cardContent = (
    <div
      className="rounded-lg p-6 shadow-lg"
      style={{
        backgroundColor: '#FFFFFF',
        color: '#000000',
        cursor: link ? 'pointer' : 'default',
      }}
    >
      {/* Logo - Larger, takes up more space */}
      {vendor.vendor_logo_url && (
        <div className="mb-4 flex items-center justify-center" style={{ minHeight: '200px', maxHeight: '300px' }}>
          <img
            src={vendor.vendor_logo_url}
            alt={`${vendor.vendor_name} logo`}
            className="max-h-48 max-w-full object-contain"
          />
        </div>
      )}

      {/* Vendor Name */}
      <h3 
        className="text-xl font-bold mb-2"
        style={{ color: '#000000' }}
      >
        {vendor.vendor_name}
      </h3>

      {/* Description */}
      {vendor.vendor_description && (
        <p 
          className="text-sm"
          style={{ color: '#000000' }}
        >
          {vendor.vendor_description}
        </p>
      )}
    </div>
  )

  if (link) {
    return <Link to={link}>{cardContent}</Link>
  }

  return cardContent
}

